{
    "en": {
        "translation": {
            "Action": "Action",
            "Add": "Add",
            "Add crewmember": "Add crewmember",
            "Advertisements": "Advertisements",
            "Attachment": "Attachment",
            "Banner": "Banner",
            "Birthdate": "Birthdate",
            "Boat": "Boat",
            "Boat data": "Boat data",
            "Boat name": "Boat name",
            "Bow no.": "Bow no.",
            "By displaying a red flag": "By displaying a red flag",
            "By hailing": "By hailing",
            "By informing her in some alternative way": "By informing her in some alternative way",
            "Can not find your region?": "Can not find your region?",
            "Canceled": "Canceled",
            "Case no.": "Case no.",
            "Championship": "Championship",
            "Championship document": "Championship document",
            "Championship regattas": "Championship regattas",
            "Championships": "Championships",
            "Change file": "Change file",
            "Checks": "Checks",
            "City": "City",
            "Close": "Close",
            "Club": "Club",
            "Coach": "Coach",
            "Coach email": "Coach email",
            "Coach name": "Coach name",
            "Coach phone": "Coach phone",
            "Confirm": "Confirm",
            "Consideration of redress by protest committee": "Consideration of redress by protest committee",
            "Consideration of reopening by protest committee": "Consideration of reopening by protest committee",
            "Contact": "Contact",
            "Country": "Country",
            "Course": "Course",
            "Created": "Created",
            "Crew": "Crew",
            "Crewmember": "Crewmember",
            "Date": "Date",
            "Day": "Day",
            "Decision": "Decision",
            "Delete entry": "Delete entry",
            "Distance": "Distance",
            "Email": "Email",
            "End date": "End date",
            "Ended": "Ended",
            "Entries": "Entries",
            "Entry": "Entry",
            "Error": "Error",
            "Expires": "Expires",
            "Female": "Female",
            "File": "File",
            "Firstname": "Firstname",
            "Gender": "Gender",
            "Give details": "Give details",
            "Group": "Group",
            "Groups": "Groups",
            "Harbor": "Harbor",
            "Hearing date": "Hearing date",
            "Image": "Image",
            "Incident description": "Incident description",
            "Incident drawing": "Incident drawing",
            "Incident drawing image": "Incident drawing image",
            "Informing protestee": "Informing protestee",
            "Items on list": "Items on list",
            "Lastname": "Lastname",
            "Login date": "Login date",
            "Logo": "Logo",
            "Logout": "Logout",
            "Make / Model": "Make / Model",
            "Male": "Male",
            "Name": "Name",
            "New": "New",
            "No": "No",
            "Notifications": "Notifications",
            "Off": "Off",
            "Organizing authority": "Organizing authority",
            "Overall results": "Overall results",
            "Page not found": "Page not found",
            "Phone": "Phone",
            "Places": "Places",
            "Plc.": "Plc.",
            "Points": "Points",
            "Preliminary crew size": "Preliminary crew size",
            "Price": "Price",
            "Privacy policy": "Privacy policy",
            "Protest by boat against boat": "Protest by boat against boat",
            "Protest by protest committee against boat": "Protest by protest committee against boat",
            "Protest by race committee against boat": "Protest by race committee against boat",
            "Protestee": "Protestee",
            "Protestor": "Protestor",
            "Pts.": "Pts.",
            "Qty.": "Qty.",
            "Qualif.": "Qualif.",
            "Qualification": "Qualification",
            "Race": "Race",
            "Race No.": "Race No.",
            "Race date": "Race date",
            "Ratings": "Ratings",
            "Reg. no.": "Reg. no.",
            "Regatta": "Regatta",
            "Regatta day": "Regatta day",
            "Regatta document": "Regatta document",
            "Regatta entry": "Regatta entry",
            "Regatta group": "Regatta group",
            "Regatta message": "Regatta message",
            "Regatta overall results": "Regatta overall results",
            "Regatta page": "Regatta page",
            "Regatta protest": "Regatta protest",
            "Regatta schedule": "Regatta schedule",
            "Regattas": "Regattas",
            "Region": "Region",
            "Regions": "Regions",
            "Registration": "Registration",
            "Registration no.": "Registration no.",
            "Request by boat or race committee to reopen hearing": "Request by boat or race committee to reopen hearing",
            "Request for redress by boat or race committee": "Request for redress by boat or race committee",
            "Role": "Role",
            "Roundings": "Ratai",
            "Rule broken": "Rule broken",
            "Sail no.": "Sail no.",
            "Sign in with Facebook": "Sign in with Facebook",
            "Sign in with Google": "Sign in with Google",
            "Skipper": "Skipper",
            "Status": "Status",
            "Successful registration to regatta": "Successful registration to regatta",
            "TBD": "TBD",
            "The list is empty": "The list is empty",
            "Title": "Title",
            "Tracker ID": "Tracker ID",
            "Tshirt": "Tshirt",
            "Twa": "Twa",
            "Tws": "Tws",
            "Type": "Type",
            "Ungrouped": "Ungrouped",
            "Unknown": "Unknown",
            "Value": "Value",
            "Weight": "Weight",
            "When": "When",
            "Where and when the incident occurred": "Where and when the incident occurred",
            "Witnesses": "Witnesses",
            "Yes": "Yes"
        }
    }
}
